<template>
  <form class="quession-form" :class="$platformClass">
    <div class="quession-containner">
      <label class="select-label" :class="$platformClass">
        <select
          :class="$platformClass"
          class="quession-select"
          v-model="quessiona"
          @change="selectAquession"
        >
          <option
            v-bind:value="quession.id"
            v-bind:disabled="quession.disabled"
            v-for="(quession, quessionIndex) in aOptions"
            v-bind:key="quessionIndex"
          >
            {{ quession.quession }}
          </option>
        </select>
        <Icon class="select-icon" type="quessionSelect"></Icon>
      </label>
      <label class="editor-wrapper bgWhite" :class="$platformClass">
        <input
          class="editor bgWhite safe-input"
          :class="$platformClass"
          v-model="answera"
          v-bind:placeholder="accountLanguages.answerTips"
        />
      </label>
    </div>
    <div class="quession-containner">
      <label class="select-label" :class="$platformClass">
        <select
          class="quession-select"
          :class="$platformClass"
          v-model="quessionb"
          @change="selectBquession"
        >
          <option
            v-bind:value="quession.id"
            v-bind:disabled="quession.disabled"
            v-for="(quession, quessionIndex) in bOptions"
            v-bind:key="quessionIndex"
          >
            {{ quession.quession }}
          </option>
        </select>
        <Icon class="select-icon" type="quessionSelect"></Icon>
      </label>
      <label class="editor-wrapper bgWhite" :class="$platformClass">
        <input
          class="editor bgWhite safe-input"
          :class="$platformClass"
          v-model="answerb"
          v-bind:placeholder="accountLanguages.answerTips"
        />
      </label>
    </div>
    <label class="agree-wrapper email-send-btn" :class="$platformClass">
      <Button
        class="btn account-setting-submit"
        @click="validateQuession"
        :type="$isOmni ? 'lightfill' : 'fillLight'"
      >
        <Icon type="commonBtnLeft"></Icon>
        <Icon type="commonBtnRight"></Icon>
        {{ accountLanguages.submit }}
      </Button>
    </label>
  </form>
</template>

<script>
import AccountSettingMixins from '../../mixins/AccountSetting';
import { VALIDATE_SECURITY_QUESSION } from '../../store/passport/accountSetting';
export const VALIDATE_SUCCESS = 'validateSuccess';
let LABEL_OPTION = [];
export default {
  name: 'validateQuession',
  props: ['validateQuessions', 'quessionRef', 'extendParam'],
  data() {
    return {
      quessiona: '',
      quessionb: '',
      answera: '',
      answerb: '',
      aOptions: [],
      bOptions: [],
    };
  },
  watch: {
    validateQuessions(quessions) {
      LABEL_OPTION = [
        {
          id: '',
          disabled: true,
          quession: this.accountLanguages.slectQuessionTips,
        },
      ];
      this.aOptions = LABEL_OPTION.concat(quessions);
      this.bOptions = LABEL_OPTION.concat(quessions);
    },
  },
  created() {
    LABEL_OPTION = [
      {
        id: '',
        disabled: true,
        quession: this.accountLanguages.slectQuessionTips,
      },
    ];
    this.aOptions = LABEL_OPTION.concat(this.validateQuessions);
    this.bOptions = LABEL_OPTION.concat(this.validateQuessions);
  },
  mixins: [AccountSettingMixins],
  methods: {
    validateQuession() {
      var params = {
        answers: [
          {
            id: this.quessiona,
            answer: this.answera,
          },
          {
            id: this.quessionb,
            answer: this.answerb,
          },
        ],
        ref: this.quessionRef,
      };
      for (var prop in this.extendParam) {
        params[prop] = this.extendParam[prop];
      }
      this.$store
        .dispatch(VALIDATE_SECURITY_QUESSION, params)
        .then(token => {
          if (token) {
            this.$emit(VALIDATE_SUCCESS, token);
          }
        })
        .catch(err => {
          this.$emit('showErrorTips', err.message);
        });
    },

    popQuessionById(id) {
      var quessions = [];
      for (var i = 0, len = this.validateQuessions.length; i < len; i++) {
        if (id !== this.validateQuessions[i].id) {
          quessions.push(this.validateQuessions[i]);
        }
      }
      return LABEL_OPTION.concat(quessions);
    },
    selectAquession() {
      this.bOptions = this.popQuessionById(this.quessiona);
    },
    selectBquession() {
      this.aOptions = this.popQuessionById(this.quessionb);
    },
  },
};
</script>
